/* Lillie & Lilah — second-image "touch peek" for product cards (2026-08, r6).
   On touch devices, resting a finger ~130ms on a product card crossfades it to
   the product's second photo, La Coqueta style: the peek is STICKY - it stays
   until a different card takes the peek, and only one card is ever peeked.
   Plain scrolling never triggers it (movement or scroll cancels the pending
   peek). Delegated from document, so it survives the Globo filter re-rendering
   the grid. Pairs with the CSS block "second-image crossfade on touch devices"
   in theme.css.liquid.
   r5: takeover sweeps EVERY peeked card (Globo re-renders can clone a peeked
   card and detach the remembered node - the sweep catches both).
   r6 (adversarial review): resolver runs on every mouseover (a Globo-cached
   card can carry a stale resolved flag with re-placeholdered images), width
   720 for sharp DPR-3 phones, all {width} tokens replaced, data-srcset also
   cleared, the arming finger is tracked by identifier so a second finger
   elsewhere can't leave a stray timer, and bfcache restore disarms.
   r7: light tap = peek. The first tap on a card shows its second image and
   does NOT navigate; tapping the same card again opens the product. (Phones
   used to fake this via simulated hover, which is what left stuck cards -
   this is the same feel, done sweepably.)
   r8: slow-scroll grazing peeks. Scrolling slowly with the finger over a
   card activates it (transferring card to card as you graze); fast flicks
   do nothing. Gated on finger velocity with a two-sample streak.
   r9: "was peeked" now means the second image is VISIBLE, not just that our
   class set it. iOS shows the second image via the :hover rule on a tap and
   then swallows that tap's click ("hover reveals content" behaviour), so the
   card could be visibly peeked while our flag said it wasn't - the next tap
   got intercepted as a fresh peek and shoppers had to tap 3+ times to open
   a product. Contract now: if you can see the second photo, your tap opens
   the product. */
(function () {
  var HAS_TOUCH = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  var SETTLE_MS = 130;   /* finger must rest this long before the peek */
  var MOVE_PX = 10;      /* more movement than this = scrolling, cancel the hold-peek */
  var SLOW_V = 0.35;     /* px per ms - slower than this while touching = deliberate graze */

  var armedCard = null;
  var armTouchId = null;
  var lastTouchTs = 0;
  var settleTimer = null;
  var startX = 0;
  var startY = 0;
  var lastMoveX = 0;
  var lastMoveY = 0;
  var lastMoveTs = 0;
  var slowStreak = 0;
  var peeked = null;

  /* The Globo filter re-renders cards with its own lazyloader; a hidden
     secondary image keeps a 1px placeholder and an unresolved data-src
     ("...width={width}"), so a peek would fade to nothing. Resolve the real
     file ourselves whenever a card is about to show it. Cards whose images
     are already resolved make this a no-op. */
  function resolveSecondary(card) {
    var imgs = card.querySelectorAll('.grid-product__secondary-image img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var u = img.getAttribute('data-src');
      if (!u) continue;
      u = u.split('{width}').join('720');
      if (u.indexOf('//') === 0) u = 'https:' + u;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('srcset');
      img.src = u;
    }
  }

  /* is the card's second image visible right now, however it got shown
     (our peek class, or iOS's tap-hover)? 0.1 catches a fade mid-flight. */
  function secondaryShowing(card) {
    var sec = card.querySelector('.grid-product__secondary-image');
    if (!sec) return false;
    var o = parseFloat(getComputedStyle(sec).opacity);
    return o > 0.1;
  }

  function disarm() {
    if (settleTimer) { clearTimeout(settleTimer); settleTimer = null; }
    armedCard = null;
    armTouchId = null;
  }

  function unpeekAll() {
    var stuck = document.querySelectorAll('.grid-product__content.is-touch-peek');
    for (var i = 0; i < stuck.length; i++) stuck[i].classList.remove('is-touch-peek');
    peeked = null;
  }

  /* desktop / any pointer: make sure hover has a real image to fade to */
  document.addEventListener('mouseover', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.grid-product__content');
    if (card) resolveSecondary(card);
  }, { passive: true });

  if (!HAS_TOUCH) return;

  document.addEventListener('touchstart', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    var target = t.target;
    if (!target || !target.closest) return;
    var card = target.closest('.grid-product__content');
    if (!card || !card.querySelector('.grid-product__secondary-image')) return;
    if (e.touches && e.touches.length > 1) { disarm(); return; }   /* pinch etc. */
    startX = t.clientX;
    startY = t.clientY;
    lastMoveX = t.clientX;
    lastMoveY = t.clientY;
    lastMoveTs = 0;
    slowStreak = 0;
    armedCard = card;
    armTouchId = t.identifier;
    lastTouchTs = Date.now();
    /* remember whether this card was already showing its second image when
       the finger landed - that decides whether the coming tap navigates.
       Checked visually (opacity), not via our class: iOS can reveal the
       image through the :hover rule without our script ever knowing. */
    if (card.classList.contains('is-touch-peek') || secondaryShowing(card)) card.setAttribute('data-ll-was-peeked', '1');
    else card.removeAttribute('data-ll-was-peeked');
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      if (armedCard) peekCard(armedCard);
    }, SETTLE_MS);
  }, { passive: true });

  function peekCard(card) {
    var stuck = document.querySelectorAll('.grid-product__content.is-touch-peek');
    for (var i = 0; i < stuck.length; i++) {
      if (stuck[i] !== card) stuck[i].classList.remove('is-touch-peek');
    }
    resolveSecondary(card);
    card.classList.add('is-touch-peek');
    peeked = card;
  }

  document.addEventListener('touchmove', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    if (!t) return;
    /* a moving finger cancels the stationary hold-peek */
    if (armedCard && (Math.abs(t.clientX - startX) > MOVE_PX || Math.abs(t.clientY - startY) > MOVE_PX)) disarm();
    /* slow-scroll graze: a slow finger over a card activates it; flicks do not */
    var now = Date.now();
    if (lastMoveTs) {
      var dt = (now - lastMoveTs) || 1;
      var dx = t.clientX - lastMoveX;
      var dy = t.clientY - lastMoveY;
      var v = Math.sqrt(dx * dx + dy * dy) / dt;
      if (v < SLOW_V) { slowStreak++; } else { slowStreak = 0; }
      if (slowStreak >= 2) {
        var el = document.elementFromPoint(t.clientX, t.clientY);
        var card = el && el.closest ? el.closest('.grid-product__content') : null;
        if (card && !card.classList.contains('is-touch-peek') && card.querySelector('.grid-product__secondary-image')) {
          peekCard(card);
        }
      }
    }
    lastMoveX = t.clientX;
    lastMoveY = t.clientY;
    lastMoveTs = now;
  }, { passive: true });

  function onEnd(e) {
    lastMoveTs = 0; slowStreak = 0;
    /* if the finger that armed the pending peek lifted, disarm - even when
       another finger is still down somewhere else on the page */
    if (armTouchId !== null && e.changedTouches) {
      for (var i = 0; i < e.changedTouches.length; i++) {
        if (e.changedTouches[i].identifier === armTouchId) { disarm(); return; }
      }
    }
    if (e.touches && e.touches.length > 0) return;   /* another finger still down */
    disarm();
    /* sticky: the peeked card keeps its second image until another card peeks */
  }
  document.addEventListener('touchend', onEnd, { passive: true });
  document.addEventListener('touchcancel', onEnd, { passive: true });

  /* first tap peeks instead of navigating; second tap on the same peeked
     card goes through to the product. Only for clicks born from a touch. */
  document.addEventListener('click', function (e) {
    if (Date.now() - lastTouchTs > 800) return;        /* not a touch-born click */
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('.grid-product__content');
    if (!card || !card.querySelector('.grid-product__secondary-image')) return;
    if (card.getAttribute('data-ll-was-peeked') === '1') return;   /* second tap: navigate */
    e.preventDefault();
    peekCard(card);
  }, false);

  /* momentum scrolling after lift-off, or any programmatic scroll */
  document.addEventListener('scroll', function () { disarm(); }, { passive: true, capture: true });

  /* back/forward-cache restore: no frozen peeks, no frozen timers */
  window.addEventListener('pageshow', function () { disarm(); unpeekAll(); });
})();
